import { render, staticRenderFns } from "./ListTeach.vue?vue&type=template&id=543cb20a&scoped=true"
import script from "./ListTeach.vue?vue&type=script&lang=js"
export * from "./ListTeach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543cb20a",
  null
  
)

export default component.exports